import PriorityIconDropdown from './PriorityIconDropdown'

const STATUS_BUTTON_COLORS = {
  idea: 'text-slate-300 bg-slate-500/10 hover:bg-slate-500/20 border-slate-500/30',
  upcoming: 'text-yellow-300 bg-yellow-500/10 hover:bg-yellow-500/20 border-yellow-500/30',
  in_progress_future: 'text-blue-300 bg-blue-500/10 hover:bg-blue-500/20 border-blue-500/30',
  ready_for_release: 'text-green-300 bg-green-500/10 hover:bg-green-500/20 border-green-500/30',
  released: 'text-green-300 bg-green-500/10 hover:bg-green-500/20 border-green-500/30',
}

function RequestRow({ request, userRole, isDragging, canEdit, onPriorityChange }) {
  const isAdmin = userRole === 'admin'
  const buttonColor = STATUS_BUTTON_COLORS[request.customer_status] || STATUS_BUTTON_COLORS.idea

  const handlePriorityChange = (newPriority) => {
    if (onPriorityChange) {
      onPriorityChange(request.link_id, newPriority)
    }
  }

  return (
    <div
      className={`
        flex items-center gap-4 px-4 py-3 ml-7 mr-4
        border-b border-xano-border/50 last:border-b-0
        transition-all duration-200
        ${isDragging ? 'opacity-50 bg-xano-cardHover shadow-lg' : 'hover:bg-xano-cardHover/50'}
        ${canEdit ? 'cursor-grab active:cursor-grabbing' : 'cursor-default'}
      `}
    >
      {/* Priority Icon */}
      <PriorityIconDropdown
        value={request.customer_priority}
        onChange={handlePriorityChange}
        disabled={!canEdit}
      />

      {/* Title - takes up most space */}
      <div className="flex-1 min-w-0">
        <span className="text-xano-text truncate block">
          {request.title}
        </span>
      </div>

      {/* Admin-only: Action buttons */}
      {isAdmin && (
        <div className="flex items-center gap-2">
          {/* Intercom button */}
          <a
            href={request.intercom_url || '#'}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex-shrink-0 flex items-center gap-1.5 px-2 py-1 text-xs font-medium border rounded transition ${buttonColor}`}
            onClick={(e) => e.stopPropagation()}
          >
            <svg
              className="w-3.5 h-3.5"
              viewBox="0 0 16 16"
              fill="currentColor"
            >
              <path d="M13.133 8.697a.467.467 0 0 1-.933 0V4.5a.466.466 0 0 1 .933 0v4.197Zm-.162 2.921c-.073.062-1.801 1.513-4.971 1.513s-4.898-1.451-4.97-1.513a.466.466 0 0 1 .606-.71c.027.024 1.571 1.29 4.364 1.29 2.828 0 4.348-1.276 4.363-1.289a.467.467 0 0 1 .607.71ZM2.867 4.5a.467.467 0 0 1 .933 0v4.197a.467.467 0 0 1-.933 0V4.5ZM5.2 3.567a.467.467 0 0 1 .933 0V9.8a.467.467 0 0 1-.933 0V3.567Zm2.333-.236a.467.467 0 1 1 .934 0v6.766a.467.467 0 0 1-.934 0V3.331Zm2.334.236a.467.467 0 0 1 .933 0V9.8a.467.467 0 0 1-.933 0V3.567ZM13.25 1H2.75A1.75 1.75 0 0 0 1 2.75v10.5c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0 0 15 13.25V2.75A1.75 1.75 0 0 0 13.25 1Z"/>
            </svg>
            Open Ticket
          </a>

          {/* Linear button */}
          {request.issue_id && (
            <a
              href={request.linear_url}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex-shrink-0 px-2 py-1 text-xs font-medium border rounded transition ${buttonColor}`}
              onClick={(e) => e.stopPropagation()}
            >
              {request.issue_id}
            </a>
          )}
        </div>
      )}
    </div>
  )
}

export default RequestRow
